import React from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import CustomDatePickerInput from "../_common/CustomDatePickerInput";

const CommentKeywordInputs = props => {
  const {
    projKeywordList,
    ck_selectedKeyword,
    ck_dateSearchType,
    ck_dateFrom,
    ck_dateTo,
    handleChange_ck_keyword,
    handleChange_ck_dateFrom,
    handleChange_ck_dateTo,
    disabled
  } = props;
  return (
    <div className="card mx-0 mb-2">
      <div className="card-body pb-2">
        <h5 className="mb-3 text-muted">Comment Keyword Report</h5>
        <div className="form-row form-group">
          <div className="col-sm-3 my-auto">
            <div className="custom-control custom-radio date-toggle">
              <input
                type="radio"
                name="allDates"
                id="allDates"
                checked={ck_dateSearchType === "allDates"}
                onChange={props.handleChange_ck_dateSearchType}
                className="custom-control-input"
                disabled={disabled}
              />
              <label htmlFor="allDates" className="custom-control-label">
                All dates
              </label>
            </div>
          </div>
        </div>
        <div className="form-row form-group">
          <div className="col-sm-3 my-auto">
            <div className="custom-control custom-radio date-toggle">
              <input
                type="radio"
                name="dateRange"
                id="dateRange"
                checked={ck_dateSearchType === "dateRange"}
                onChange={props.handleChange_ck_dateSearchType}
                className="custom-control-input"
                disabled={disabled}
              />
              <label htmlFor="dateRange" className="custom-control-label">
                Date range:
              </label>
            </div>
          </div>
          <div className="col-sm-9">
            <div className="row mb-0 ml-0">
              <label htmlFor="dateFrom" className="form-label mx-2 my-auto">
                From:
              </label>
              <div className="col-sm-4">
                <DatePicker
                  customInput={<CustomDatePickerInput />}
                  name="dateFrom"
                  id="dateFrom"
                  selected={ck_dateFrom}
                  onChange={value => handleChange_ck_dateFrom(value)}
                  disabled={disabled || ck_dateSearchType !== "dateRange"}
                />
              </div>
              <label htmlFor="dateTo" className="form-label mx-2 my-auto">
                To:
              </label>
              <div className="col-sm-4">
                <DatePicker
                  customInput={<CustomDatePickerInput />}
                  name="dateTo"
                  id="dateTo"
                  selected={ck_dateTo}
                  onChange={value => handleChange_ck_dateTo(value)}
                  disabled={disabled || ck_dateSearchType !== "dateRange"}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form-row form-group">
          <div className="col-sm-3 my-auto">
            <label htmlFor="items" className="col-form-label">
              Keyword:
            </label>
          </div>
          <div className="col-sm-9 my-auto">
            <Select
              name="itemIds"
              id="itemIds"
              value={ck_selectedKeyword}
              options={
                projKeywordList &&
                projKeywordList.map(k => ({
                  value: k.keywordId,
                  label: k.keywordTag
                }))
              }
              onChange={value => handleChange_ck_keyword(value)}
              placeholder="(Select or Key-in a Keyword)"
              isSearchable
              isDisabled={disabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentKeywordInputs;
